import CryptoJS from 'crypto-js';

// Load and parse environment variables
const secretKey = import.meta.env.VITE_SECRET_KEY;
const aesKey = import.meta.env.VITE_AES_KEY;
const aesIV = import.meta.env.VITE_AES_IV;

// Parse Base64 AES key and IV
const parsedKey = CryptoJS.enc.Base64.parse(aesKey);
const parsedIV = CryptoJS.enc.Base64.parse(aesIV);

// -- Storage Encryption (using simple secret key) --

export function encryptSotrageData(data) {
  const input = typeof data === 'object' ? JSON.stringify(data) : String(data);
  // const encrypted = CryptoJS.AES.encrypt(input, secretKey);
  return input.toString();
}

export function decryptStorageData(encryptedData) {
  // const decrypted = CryptoJS.AES.decrypt(encryptedData, secretKey);
  // const result = decrypted.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(encryptedData);
  } catch {
    return encryptedData;
  }
}

// -- AES Encryption/Decryption with Key + IV --

export function encryptAES(data) {
  const input = typeof data === 'object' ? JSON.stringify(data) : String(data);
  const encrypted = CryptoJS.AES.encrypt(input, parsedKey, {
    iv: parsedIV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

export function decryptAES(encryptedData) {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, parsedKey, {
    iv: parsedIV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const result = decrypted.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(result);
  } catch {
    return result;
  }
}

// -- History-specific AES Encryption --

export function encryptHistoryAES(data) {
  return encryptAES(data); // Reuse encryptAES for consistency
}

// -- URL-safe Encryption/Decryption --

export function encryptUrlData(data) {
  return encryptAES(data)
    .replaceAll('/', 's2e0s21')
    .replaceAll('+', 's2e0s22');
}

export function decryptUrlData(data) {
  const normalized = data
    .replaceAll('s2e0s21', '/')
    .replaceAll('s2e0s22', '+');
  return decryptAES(normalized);
}
